module.exports = __webpack_public_path__ + "img/image_login.ce72986b.gif";